import { render } from "./EventInputField.vue?vue&type=template&id=55e7d03a"
import script from "./EventInputField.vue?vue&type=script&lang=js"
export * from "./EventInputField.vue?vue&type=script&lang=js"
script.render = render

export default script